<template functional>
    <div class="d-flex justify-content-center align-items-center w-100">
        <div class="text-center">
            <b-icon icon="check" variant="success" class="p-1 rounded-circle bg-success-100" :font-scale="props.iconFontScale"></b-icon>
            <h4 class="text-muted mt-3 mb-0">{{props.message}}</h4>
        </div>
    </div>
</template>

<script>

export default {
    functional: true,
    name: 'SaveSuccess',
    props: {
        message: {
            type: String,
            default: 'Saved'
        },
        iconFontScale: {
            type: String,
            default: '3',
        }
    },
}
</script>

<style>

</style>